import { arrivalNoticeStrings } from '@data/arrivalNotice';
import { deliveryRequestStrings } from '@data/deliveryRequest';
import { z } from 'zod';

export const DeliveryRequestPickupAddress = z.object({
  delivery_destination: z.string().label(deliveryRequestStrings.pickupAddress),
  delivery_destination_code: z.string().label(arrivalNoticeStrings.delivery_destination_code),
  repository: z.string().label(arrivalNoticeStrings.repository),
  address: z.string().label(arrivalNoticeStrings.address),
  tel: z.string().label(arrivalNoticeStrings.tel),
  fax: z.string().label(arrivalNoticeStrings.fax),
  principal_name: z.string().label(arrivalNoticeStrings.principal_name),
});

export type DeliveryRequestPickupAddress = z.infer<typeof DeliveryRequestPickupAddress>;
